import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { trackPageView } from './utils/analytics';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Problem from './pages/Problem';
import Scorecard from './pages/Scorecard';
import Sentinel from './pages/Sentinel';
import Forecaster from './pages/Forecaster';
import Notes from './pages/Notes';
import Methods from './pages/Methods';
import Contribute from './pages/Contribute';
import About from './pages/About';

const NoteStory = React.lazy(() => import('./pages/NoteStory'));

// Scroll to top and record a page view on every route change.
const RouteEffects: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <RouteEffects />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/problem" element={<Problem />} />
            <Route path="/scorecard" element={<Scorecard />} />
            <Route path="/sentinel" element={<Sentinel />} />
            <Route path="/forecaster" element={<Forecaster />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/notes/:slug" element={<React.Suspense fallback={<div className="section-padding" />}><NoteStory /></React.Suspense>} />
            <Route path="/methods" element={<Methods />} />
            <Route path="/contribute" element={<Contribute />} />
            <Route path="/about" element={<About />} />
            {/* Old company-site routes: send visitors to the closest current page. */}
            <Route path="/services" element={<Navigate to="/methods" replace />} />
            <Route path="/technology" element={<Navigate to="/methods" replace />} />
            <Route path="/team" element={<Navigate to="/about" replace />} />
            <Route path="/contact" element={<Navigate to="/contribute" replace />} />
            <Route path="/get-started" element={<Navigate to="/contribute" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
